<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 20H7V4H17V20ZM11.375 17.7148V18.8574H12.625V17.7148H11.375ZM8.25 5.71484V17.1436H15.75V5.71484H8.25Z"
      fill="currentColor"
    />
  </svg>
</template>
